import { render } from "./SettingUpdateAlert.vue?vue&type=template&id=6017298d&scoped=true"
import script from "./SettingUpdateAlert.vue?vue&type=script&lang=js"
export * from "./SettingUpdateAlert.vue?vue&type=script&lang=js"

import "./SettingUpdateAlert.vue?vue&type=style&index=0&id=6017298d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6017298d"]])

export default __exports__